module.exports = __webpack_public_path__ + "img/devicesNum.ee494e02.svg";